import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CompaniesService } from 'src/app/services/api/general-settings/companies.service';
import { CompanyFormComponent } from '../components/company-form/company-form.component';

@Component({
  selector: 'app-companies-edit-page',
  imports: [CompanyFormComponent],
  templateUrl: './companies-edit-page.component.html',
  styleUrl: './companies-edit-page.component.scss'
})
export class CompaniesEditPageComponent {
  companyId!: number
  company?: any;

  constructor(
    private route: ActivatedRoute,
    private companiesService: CompaniesService,
  ) {
  }

  ngOnInit(): void {
    this.companyId = Number(this.route.snapshot.paramMap.get('companyId'));
    if (this.companyId) {
      this.loadData(this.companyId);
    }
  }

  loadData(companyId: any) {
    this.companiesService.detail(companyId).subscribe((response: any) => {
      this.company = response.data?.company;
    });

  }
}
